import React from 'react'
import './../assets/table.css'
import moment from 'moment-timezone'
import VerificationTitle from './VerificationTitle'
// import StandardButton from './StandardButton'
import StandardButtonWithRadio from './StandardButtonWithRadio'
import VerificationSave from './VerificationSave'
import calendarDisabled from '../images/calendarDisabled.svg'
import enabledVerticalTicketIcon from '../images/enabledVerticalTicketIcon.svg'
import disabledRadio from '../images/disabledRadio.svg'
import enabledRadio from '../images/enabledRadio.svg'
import closeIcon from '../images/closeIcon.svg'
import t from 'tcomb-form'
import _ from 'lodash'
import { getTemplates } from '../components/Templates/templates'
import { client } from '../graphql/client'
import {
  UPDATE_EVENT_SELECTED_TO_VALID_STATUS_WITH_VALUE,
  UPDATE_EVENT_SELECTED_TO_INVALID_STATUS_WITH_VALUE,
  UPDATE_EVENT_SELECTED_TO_INVALID_STATUS_WITHOUT_VALUE,
  UPDATE_EVENT_SELECTED_TO_INVALID_STATUS_WITH_VALUE_AND_DELTA
} from '../query/event'
import {
  refreshToken
} from '../utils/token'
import {
  getUserInfo
} from '../utils/userInfo'
import Modal from 'react-responsive-modal'
import CircularProgress from '@material-ui/core/CircularProgress'
import config from '../config'
moment.locale('fr')

const templates = getTemplates()
const Form = t.form.Form

const FormSchema = t.struct({
  note: t.String
})

const options = {
  fields: {
    note: {
      label: 'Votre commentaire',
      template: templates['note']
    }
  }
}

class EventVerificationComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      value: null,
      reference: 'note',
      validEnabledRadio: false,
      invalidEnabledRadio: false,
      invalidEnabledRadioWithDelta: false,
      dataOfSelectedEvent: null,
      selectedTicketId: null,
      eventState: null,
      openModalForSelectTicket: false,
      openModalForSubmit: false,
      quantityOfSelectedTicket: null
    }
  }

  UNSAFE_componentWillMount () {
    const self = this
    var token = localStorage.getItem('token')
    getUserInfo(token)
      .then(response => response.json())
      .then(function (data) {
        if (data.error && data.error.code === 401) {
          refreshToken(localStorage.getItem('refresh_token'))
        }
        self.getTicketsBySelectedEvent()
      })
      .catch((error) => {
        console.log('error: ', error)
      })
  }

  getDefaultSelectedTicket (eventSelected, tickets) {
    let defaultSelectedTicket
    if (tickets) {
      tickets.forEach(function (element) {
        if (moment.utc(element.value.date_time).tz('Indian/Antananarivo').format('DD/MM/YYYY') === moment.utc(eventSelected[0].occurred_at).tz('Indian/Antananarivo').format('DD/MM/YYYY')) {
          defaultSelectedTicket = element
        }
      })
    }
    return defaultSelectedTicket
  }

  onSubmit (evt) {
    const self = this
    evt.preventDefault()
    self.setState({
      openModalForSubmit: true
    })
  }

  updateEventStatus () {
    const self = this
    var token = localStorage.getItem('token')
    let selectedEventId = self.props.selectedEventId
    let eventState = self.state.eventState
    let quantityOfSelectedTicket = self.state.quantityOfSelectedTicket
    let selectedTicketId = self.state.selectedTicketId
    const note = this.refs[this.state.reference].getValue()
    getUserInfo(token)
      .then(response => response.json())
      .then(function (data) {
        if (data.error && data.error.code === 401) {
          refreshToken(localStorage.getItem('refresh_token'))
        }
        let delta = self.getDeltaValue(quantityOfSelectedTicket).replace(/%/g, '')
        let variables
        if (eventState === 'invalidWithDelta') {
          if (note) {
            variables = { id: selectedEventId, value: { 'ticket_id': selectedTicketId, 'notes': note.note, 'delta': delta } }
          } else {
            variables = { id: selectedEventId, value: { 'ticket_id': selectedTicketId, 'delta': delta } }
          }
          client
            .mutate({
              mutation: UPDATE_EVENT_SELECTED_TO_INVALID_STATUS_WITH_VALUE_AND_DELTA,
              variables: variables
            })
            .then(result => {
              self.updateTicketStatus()
            }).catch(error => console.log(error))
        }
        if (eventState === 'valid') {
          if (note) {
            variables = { id: selectedEventId, value: { 'ticket_id': selectedTicketId, 'notes': note.note } }
          } else {
            variables = { id: selectedEventId, value: { 'ticket_id': selectedTicketId } }
          }
          client
            .mutate({
              mutation: UPDATE_EVENT_SELECTED_TO_VALID_STATUS_WITH_VALUE,
              variables: variables
            })
            .then(result => {
              self.updateTicketStatus()
            }).catch(error => console.log(error))
        }
        if (eventState === 'invalid') {
          if (note) {
            variables = { id: selectedEventId, value: { 'notes': note.note } }
            client
              .mutate({
                mutation: UPDATE_EVENT_SELECTED_TO_INVALID_STATUS_WITH_VALUE,
                variables: variables
              })
              .then(result => {
                self.props.onClose()
                self.refreshPage()
              }).catch(error => console.log(error))
          } else {
            variables = { id: selectedEventId }
            client
              .mutate({
                mutation: UPDATE_EVENT_SELECTED_TO_INVALID_STATUS_WITHOUT_VALUE,
                variables: variables
              })
              .then(result => {
                self.props.onClose()
                self.refreshPage()
              }).catch(error => console.log(error))
          }
        }
      })
      .catch((error) => {
        console.log('error: ', error)
      })
  }

  updateTicketStatus () {
    const self = this
    let eventState = self.state.eventState
    let selectedTicketId = self.state.selectedTicketId
    let selectedEventId = self.props.selectedEventId
    if (selectedTicketId) {
      let attributes
      if (eventState === 'valid') {
        attributes = {
          checked: true,
          state: 'valid',
          event_id: selectedEventId
        }
      }
      if (eventState === 'invalidWithDelta') {
        attributes = {
          checked: true,
          state: 'invalid',
          event_id: selectedEventId
        }
      }
      let body = {
        data: {
          type: 'FUEL_SENSOR_TICKET',
          attributes: attributes
        }
      }
      fetch(`${config.couchdb_jsonapi}fuel_sensor_ticket/${selectedTicketId}`, {
        method: 'PUT',
        body: JSON.stringify(body),
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/vnd.api+json'
        }
      }).then(response => {
        response.json()
        self.props.onClose()
        self.refreshPage()
      }).catch(error => console.log(error))
    } else {
      self.props.onClose()
      self.refreshPage()
    }
  }

  refreshPage () {
    window.location.reload()
  }

  confirmValidation () {
    const self = this
    self.onCloseModalForSubmit()
    self.updateEventStatus()
  }

  onChange (value) {
    console.log("Value: ",value)
    this.setState({
      value: value
    })
  }

  onClickRow (id, quantity) {
    const self = this
    self.setState({
      selectedTicketId: id,
      quantityOfSelectedTicket: quantity
    })
  }

  getDeltaValue (quantityInTicket) {
    const self = this
    let eventSelected = self.props.eventSelected
    let quantityInEvent = eventSelected[0].value
    let tankCapacity = eventSelected[0].metadata.tank_capacity
    let margin = tankCapacity / 100
    let difference = (quantityInTicket - quantityInEvent).toFixed(2)
    let delta = ((Math.abs(difference) - margin) / margin).toFixed(2)
    if (Math.abs(difference) <= margin) {
      return '-'
    }
    if (difference < 0 && (Math.abs(difference) > margin)) {
      return ('-' + delta + '%')
    }
    if (difference > 0 && (Math.abs(difference) > margin)) {
      return (delta + '%')
    }
  }

  getTicketsBySelectedEvent () {
    let self = this
    let trbImm = self.props.trbImm
    fetch(
      `${config.couchdb_final_docs}BySelectedEvent?key="${trbImm}"`,
      { headers: { 'Access-Control-Allow-Origin': '*' } }
    )
      .then(response => response.json())
      .then((data) => {
        let tickets = data.rows
        let defaultSelectedTicket = self.getDefaultSelectedTicket(self.props.eventSelected, tickets)
        this.setState({
          dataOfSelectedEvent: tickets,
          selectedTicketId: defaultSelectedTicket ? defaultSelectedTicket.id : null,
          quantityOfSelectedTicket: defaultSelectedTicket ? defaultSelectedTicket.value.quantity : null
        })
      })
      .catch(error => { console.log(error) })
  }

  updateToOffenseWithDelta () {
    const self = this
    if (self.state.selectedTicketId) {
      self.setState({
        eventState: self.state.eventState === 'invalidWithDelta' ? null : 'invalidWithDelta',
        invalidEnabledRadioWithDelta: !self.state.invalidEnabledRadioWithDelta,
        invalidEnabledRadio: false,
        validEnabledRadio: false
      })
    } else {
      self.setState({
        openModalForSelectTicket: true
      })
    }
  }

  updateToChecked () {
    const self = this
    if (self.state.selectedTicketId) {
      self.setState({
        eventState: self.state.eventState === 'valid' ? null : 'valid',
        validEnabledRadio: !self.state.validEnabledRadio,
        invalidEnabledRadio: false,
        invalidEnabledRadioWithDelta: false
      })
    } else {
      self.setState({
        openModalForSelectTicket: true
      })
    }
  }

  updateToOffense () {
    const self = this
    self.setState({
      eventState: self.state.eventState === 'invalid' ? null : 'invalid',
      invalidEnabledRadio: !self.state.invalidEnabledRadio,
      validEnabledRadio: false,
      invalidEnabledRadioWithDelta: false
    })
  }

  onCloseModalForSelectTicket () {
    const self = this
    self.setState({
      openModalForSelectTicket: false
    })
  }

  onCloseModalForSubmit () {
    const self = this
    self.setState({
      openModalForSubmit: false
    })
  }

  renderLeftContent () {
    let eventSelected = this.props.eventSelected
    return (
      <div style={styles.leftContent}>
        <VerificationTitle
          title='Evénement'
          img={calendarDisabled} />
        <div style={styles.section}>
          <table style={styles.table}>
            <thead>
              <tr style={styles.trHeader}>
                <th style={styles.thContentLeft}>
                  <span style={styles.labelThLeft}>Date</span>
                </th>
                <th style={styles.thContentLeft}>Véhicules</th>
                <th style={styles.thContentLeft}>Volume</th>
                <th style={styles.thContentLeft}>Station service</th>
              </tr>
            </thead>
            <tbody>
              <tr style={styles.trContentLeft}>
                <td className='tdVerificationLeft' style={styles.td}>
                  <span style={styles.labelTdLeft}>{moment.utc(eventSelected[0].occurred_at).tz('Indian/Antananarivo').format('DD/MM/YYYY')}</span><br />
                  <span style={styles.labelTdLeft}>{moment.utc(eventSelected[0].occurred_at).tz('Indian/Antananarivo').format('HH:mm:ss')}</span>
                </td>
                <td className='tdVerification' style={styles.td}>{eventSelected[0].metadata.trb_imm}</td>
                <td className='tdVerification' style={styles.td}>{Math.round(eventSelected[0].value)} Litres</td>
                <td className='tdVerificationRight' style={styles.td}>{eventSelected[0].gas_station !== '' ? eventSelected[0].gas_station : '-'}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr style={styles.hr} />
        {/* <div style={styles.contentButtonLeft}>
          <StandardButton
            label='CHUTE VOLUME PARKING'
          />
          <StandardButton
            label='CONSO.HORS NORME'
          />
        </div> */}
      </div>
    )
  }

  sortDataOfSelectedEventToDesc () {
    const self = this
    let dataOfSelectedEvent = self.state.dataOfSelectedEvent
    let dataOfSelectedEventSorted
    if (dataOfSelectedEvent) {
      dataOfSelectedEventSorted = _.orderBy(dataOfSelectedEvent, function (value) {
        return new Date(value.value.date_time)
      }, 'desc')
    }
    return dataOfSelectedEventSorted
  }

  renderRightContent () {
    const self = this
    let dataOfSelectedEvent = self.sortDataOfSelectedEventToDesc()
    if (!dataOfSelectedEvent) {
      return (
        <div style={styles.rightContent}>
          <VerificationTitle
            title='Tickets disponibles'
            img={enabledVerticalTicketIcon} />
          <div style={styles.parentSection}>
            <div style={styles.section}>
              <CircularProgress style={{ color: '#7ED321', marginTop: '50px', marginLeft: '360px' }} color='inherit' />
            </div>
          </div>
          <hr style={styles.hr} />
          <div style={styles.contentButtonRight}>
            <StandardButtonWithRadio
              label='DELTA SUPERIEUR'
              onClick={() => self.updateToOffenseWithDelta()}
              enabledRadio={self.state.invalidEnabledRadioWithDelta}
            />
            <StandardButtonWithRadio
              label='CE TICKET EST CONFORME'
              onClick={() => self.updateToChecked()}
              enabledRadio={self.state.validEnabledRadio}
            />
            <StandardButtonWithRadio
              label='AUCUN TICKET A ASSOCIER'
              onClick={() => self.updateToOffense()}
              enabledRadio={self.state.invalidEnabledRadio}
            />
          </div>
        </div>
      )
    }
    return (
      <div style={styles.rightContent}>
        <VerificationTitle
          title='Tickets disponibles'
          img={enabledVerticalTicketIcon} />
        <div style={styles.parentSection}>
          <div style={styles.section}>
            <table style={styles.table}>
              <thead>
                <tr style={styles.trHeader}>
                  <th style={styles.myThContentRight} />
                  <th style={styles.thContentRight}>
                    <span style={styles.labelThLeft}>Date</span>
                  </th>
                  <th style={styles.thContentRight}>Véhicules</th>
                  <th style={styles.thContentRight}>Volume</th>
                  <th style={styles.thContentRight}>Station service</th>
                  <th style={styles.myThContentRight}>Delta</th>
                </tr>
              </thead>
              {dataOfSelectedEvent
                ? <tbody>
                  {dataOfSelectedEvent.map((value, key) => {
                    let myValue = value.value
                    if (value.id === this.state.selectedTicketId) {
                      return (
                        <tr
                          key={key}
                          style={styles.trContent}
                          onClick={() => self.onClickRow()}>
                          <td className='tdVerificationLeftSelected' style={styles.tdContentRight}>
                            <img src={enabledRadio} alt='true' />
                          </td>
                          <td className='tdVerificationSelected' style={styles.tdSelected}>
                            <span style={styles.labelTdLeftSelected}>{moment.utc(myValue.date_time).tz('Indian/Antananarivo').format('DD/MM/YYYY')}</span><br />
                            <span style={styles.labelTdLeftSelected}>{moment.utc(myValue.date_time).tz('Indian/Antananarivo').format('HH:mm:ss')}</span>
                          </td>
                          <td className='tdVerificationSelected' style={styles.tdSelected}>{myValue.vehicle_number}</td>
                          <td className='tdVerificationSelected' style={styles.tdSelected}>{myValue.quantity.toFixed(2)} Litres</td>
                          <td className='tdVerificationSelected' style={styles.tdSelected}>{myValue.sale_point}</td>
                          <td className='tdVerificationRightSelected' style={styles.tdSelected}>{self.getDeltaValue(myValue.quantity)}</td>
                        </tr>
                      )
                    }
                    return (
                      <tr
                        key={key}
                        style={styles.trContent}
                        onClick={() => self.onClickRow(value.id, myValue.quantity)}
                      >
                        <td className='tdVerificationLeft' style={styles.tdContentRight}>
                          <img src={disabledRadio} alt='true' />
                        </td>
                        <td className='tdVerification' style={styles.td}>
                          <span style={styles.labelTdLeft}>{moment.utc(myValue.date_time).tz('Indian/Antananarivo').format('DD/MM/YYYY')}</span><br />
                          <span style={styles.labelTdLeft}>{moment.utc(myValue.date_time).tz('Indian/Antananarivo').format('HH:mm:ss')}</span>
                        </td>
                        <td className='tdVerification' style={styles.td}>{myValue.vehicle_number}</td>
                        <td className='tdVerification' style={styles.td}>{myValue.quantity.toFixed(2)} Litres</td>
                        <td className='tdVerification' style={styles.td}>{myValue.sale_point}</td>
                        <td className='tdVerificationRight' style={styles.td}>{self.getDeltaValue(myValue.quantity)}</td>
                      </tr>
                    )
                  })}
                </tbody> : null
              }
            </table>
          </div>
        </div>
        <hr style={styles.hr} />
        <div style={styles.contentButtonRight}>
          <StandardButtonWithRadio
            label='DELTA SUPERIEUR'
            onClick={() => self.updateToOffenseWithDelta()}
            enabledRadio={self.state.invalidEnabledRadioWithDelta}
          />
          <StandardButtonWithRadio
            label='CE TICKET EST CONFORME'
            onClick={() => self.updateToChecked()}
            enabledRadio={self.state.validEnabledRadio}
          />
          <StandardButtonWithRadio
            label='AUCUN TICKET A ASSOCIER'
            onClick={() => self.updateToOffense()}
            enabledRadio={self.state.invalidEnabledRadio}
          />
        </div>
      </div>
    )
  }

  renderModalContentForSubmit () {
    const self = this
    let eventState = self.state.eventState
    let selectedTicketId = self.state.selectedTicketId
    if (eventState !== null) {
      if (eventState === 'invalid') {
        return (
          <div>
            <h2 style={styles.modalTitleForSubmit}>Modifier état d'événement</h2>
            <p style={styles.modalText}>
              Voulez vous mettre l'état de l'événement comme infraction ?
            </p>
            <div>
              <button style={styles.modalButtonLeft} onClick={() => this.onCloseModalForSubmit()}><span>Annuler</span></button>
              <button style={styles.modalButtonRight} onClick={() => this.confirmValidation()}>Modifier</button>
            </div>
          </div>
        )
      } else {
        if (selectedTicketId) {
          if (eventState === 'valid') {
            return (
              <div>
                <h2 style={styles.modalTitleForSubmit}>Modifier état d'événement</h2>
                <p style={styles.modalText}>
                  Voulez vous mettre l'état de l'événement comme conforme ?
                </p>
                <div>
                  <button style={styles.modalButtonLeft} onClick={() => this.onCloseModalForSubmit()}><span>Annuler</span></button>
                  <button style={styles.modalButtonRight} onClick={() => this.confirmValidation()}>Modifier</button>
                </div>
              </div>
            )
          }
          return (
            <div>
              <h2 style={styles.modalTitleForSubmit}>Modifier état d'événement</h2>
              <p style={styles.modalText}>
                Voulez vous mettre l'état de l'événement comme infraction avec delta ?
              </p>
              <div>
                <button style={styles.modalButtonLeft} onClick={() => this.onCloseModalForSubmit()}><span>Annuler</span></button>
                <button style={styles.modalButtonRight} onClick={() => this.confirmValidation()}>Modifier</button>
              </div>
            </div>
          )
        } else {
          return (
            <div>
              <h2 style={styles.modalTitleForSubmit}>Aucun ticket sélectionné</h2>
              <div style={styles.buttonContentCenter}>
                <button onClick={() => this.onCloseModalForSubmit()}><span>Fermer</span></button>
              </div>
            </div>
          )
        }
      }
    } else {
      return (
        <div>
          <h2 style={styles.modalTitleForSubmit}>Aucun état sélectionné</h2>
          <div style={styles.buttonContentCenter}>
            <button onClick={() => this.onCloseModalForSubmit()}><span>Fermer</span></button>
          </div>
        </div>
      )
    }
  }

  render () {
    return (
      <div style={styles.container}>
        <div style={styles.contentIcon}>
          <img
            src={closeIcon}
            width='16px'
            height='16px'
            alt='true'
            onClick={this.props.onClose}
          />
        </div>
        <div style={styles.contentTitle}>
          <span style={styles.modalTitle}>VERIFICATION D'EVENEMENT</span>
        </div>
        <div>
          {this.renderLeftContent()}
          {this.renderRightContent()}
        </div>
        <div style={styles.formContent}>
          <form
            onSubmit={(e) => this.onSubmit(e)}>
            <div>
              <div style={styles.fieldContent}>
                <Form
                  ref={this.state.reference}
                  type={FormSchema}
                  options={options}
                  value={this.state.value}
                  onChange={(value) => this.onChange(value)}
                />
              </div>
              <div style={styles.contentButtonSave}>
                <VerificationSave
                  label='VALIDER'
                  type='submit'
                />
              </div>
            </div>
          </form>
        </div>
        <div>
          <Modal
            styles={bg}
            open={this.state.openModalForSelectTicket}
            onClose={() => this.onCloseModalForSelectTicket()}
            showCloseIcon={false}
            focusTrapped={false}>
            <h2 style={styles.modalTitleForSelectTicket}>Aucun ticket sélectionné</h2>
            <div style={styles.buttonContentCenter}>
              <button onClick={() => this.onCloseModalForSelectTicket()}><span>Fermer</span></button>
            </div>
          </Modal>
        </div>
        <div>
          <Modal
            styles={bg}
            open={this.state.openModalForSubmit}
            onClose={() => this.onCloseModalForSubmit()}
            showCloseIcon={false}
            focusTrapped={false}>
            {this.renderModalContentForSubmit()}
          </Modal>
        </div>
      </div>
    )
  }
}

const bg = {
  modal: {
    background: '#364248',
    borderRadius: '6px',
    color: '#F2F2F2'
  }
}

const styles = {
  container: {
    width: '1320px',
    marginTop: '-20px'
  },
  contentIcon: {
    float: 'right',
    cursor: 'pointer'
  },
  contentTitle: {
    marginTop: '20px',
    width: '1180px',
    textAlign: 'center'
  },
  leftContent: {
    float: 'left',
    width: '510px'
  },
  rightContent: {
    float: 'right',
    width: '770px'
  },
  modalTitle: {
    fontWeight: 'bold',
    fontSize: '12px',
    color: '#F2F2F2'
  },
  parentSection: {
    width: '100%',
    overflow: 'hidden'
  },
  section: {
    width: '100%',
    paddingRight: '17px',
    marginTop: '30px',
    height: '402px',
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  table: {
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: '0 16px'
  },
  trHeader: {
    height: '42px'
  },
  thContentLeft: {
    width: '25%',
    textAlign: 'left',
    marginLeft: '82px',
    color: '#A6B9C8',
    fontSize: '14px',
    fontWeight: 500,
    fontStyle: 'normal'
  },
  myThContentRight: {
    width: '10%',
    textAlign: 'left',
    marginLeft: '82px',
    color: '#A6B9C8',
    fontSize: '14px',
    fontWeight: 500,
    fontStyle: 'normal'
  },
  thContentRight: {
    width: '20%',
    textAlign: 'left',
    marginLeft: '82px',
    color: '#A6B9C8',
    fontSize: '14px',
    fontWeight: 500,
    fontStyle: 'normal'
  },
  labelThLeft: {
    marginLeft: '10px',
    fontWeight: 500,
    fontStyle: 'normal'
  },
  trContentLeft: {
    height: '62px',
    marginTop: '12px'
  },
  trContent: {
    cursor: 'pointer',
    height: '62px',
    marginTop: '12px'
  },
  labelTdLeft: {
    marginLeft: '20px',
    color: '#F2F2F2',
    fontSize: '14px',
    fontWeight: 'bold'
  },
  labelTdLeftSelected: {
    marginLeft: '20px',
    color: '#7ED321',
    fontSize: '14px',
    fontWeight: 'bold'
  },
  td: {
    color: '#F2F2F2',
    fontSize: '14px',
    fontWeight: 'bold'
  },
  tdSelected: {
    color: '#7ED321',
    fontSize: '14px',
    fontWeight: 'bold'
  },
  tdContentRight: {
    textAlign: 'center'
  },
  contentButtonRight: {
    float: 'right'
  },
  contentButtonLeft: {
    float: 'left',
    marginLeft: '-12px',
    marginBottom: '36px'
  },
  formContent: {
    width: '100%',
    height: '206px',
    marginTop: '630px'
  },
  fieldContent: {
    float: 'left'
  },
  contentButtonSave: {
    marginTop: '150px',
    float: 'right'
  },
  hr: {
    marginTop: '32px'
  },
  modalTitleForSelectTicket: {
    marginTop: '-10px',
    textAlign: 'center'
  },
  buttonContentCenter: {
    textAlign: 'center'
  },
  modalTitleForSubmit: {
    marginTop: '-10px',
    textAlign: 'center'
  },
  modalText: {
    fontSize: '12px'
  },
  modalButtonLeft: {
    float: 'left',
    width: '100px',
    borderWidth: '0px',
    height: '24px',
    borderRadius: '3px'
  },
  modalButtonRight: {
    borderWidth: '0px',
    float: 'right',
    width: '100px',
    height: '24px',
    borderRadius: '3px'
  }
}

export default EventVerificationComponent
